import React from 'react';
import { motion } from 'framer-motion';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { FadeIn } from './FadeIn';
import { AnimatedBackground } from './AnimatedBackground';
import { scrollToForm } from '../utils/scroll';
export function FinalCta() {
  return <section className="cv-auto relative w-full overflow-hidden bg-[linear-gradient(135deg,#071F5C,#1B4DCC)] px-6 py-28 text-center" data-id="element-57" data-mp="15dlvf1xpx2uq">
      <AnimatedBackground intensity="soft" icons data-id="element-58" data-mp="1jc3h6u42c5a0" />

      <FadeIn className="relative mx-auto max-w-[1100px]" data-id="element-59" data-mp="1ee1wy5uwhzwy">
        <h2 className="mb-4 font-display text-[clamp(32px,5vw,54px)] font-extrabold leading-tight text-white" data-id="element-60" data-mp="1edip5hyysrwn">
          Tu competencia ya
          <br data-id="element-61" data-mp="1o3v5sz3ns0xi" />
          está en Google.
          <br data-id="element-62" data-mp="1o4wkddjvv5jz" />
          <span className="text-brand-yellow" data-id="element-63" data-mp="1o4db0l8atphk">¿Y tú?</span>
        </h2>
        <p className="mx-auto mb-10 max-w-[500px] text-lg leading-relaxed text-white/75" data-id="element-64" data-mp="222uychuakzyy">
          Cada día sin web es un día que tus clientes eligen a alguien más.
          Arréglalo hoy.
        </p>

        <motion.button type="button" onClick={scrollToForm} whileHover={{
        y: -4,
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 18
      }} className="group relative inline-flex items-center gap-3 overflow-hidden rounded-full bg-brand-yellow px-10 py-5 font-display text-lg font-extrabold text-brand-deep shadow-glow focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-deep" data-id="element-65" data-mp="n6nul8d98n1j">
          <span aria-hidden="true" className="absolute inset-y-0 -left-1/3 w-1/3 skew-x-12 animate-shimmer bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.7),transparent)]" data-id="element-66" data-mp="1fu9vg8v3ldkp" />
          <RocketLaunchIcon sx={{
          fontSize: 22
        }} data-id="element-67" data-mp="1pszew62n7632" />
          Cotiza Tu Web Ahora
        </motion.button>

        <p className="mt-5 text-sm text-white/60" data-id="element-68" data-mp="1tt9lnky9e0iz">
          Sin compromiso · Respuesta por WhatsApp en menos de 24 horas
        </p>
      </FadeIn>
    </section>;
}